import { apiRequest } from '@peruselab/api-client/httpRequest';
import type { ScientificObjectRef } from '../../scientific-objects/ScientificObjectRef';
import type { ScientificRelationship } from './ScientificRelationship';

export type RelationshipDirection = 'outgoing' | 'incoming';

export async function getRelationships(
  direction: RelationshipDirection,
  reference: ScientificObjectRef
): Promise<readonly ScientificRelationship[]> {
  const query = new URLSearchParams({ type: reference.type, id: reference.id });
  return apiRequest<ScientificRelationship[]>(`/scientific-relationships/${direction}?${query}`, 'relationship');
}
